const requireAll = requireContext => requireContext.keys().map(requireContext)

const req = require.context('./', true, /\.css$/)
requireAll(req)
